import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/** Surfaces claras con tinte celeste, tomadas del Poseidon en modo claro. */
const poseidonSurface = {
  0: '#ffffff',
  50: '#f0f9ff',
  100: '#e0f2fe',
  200: '#c5dff0',
  300: '#a3c4d9',
  400: '#7da3b8',
  500: '#5e8499',
  600: '#4a6d80',
  700: '#385668',
  800: '#284050',
  900: '#1a2c3a',
  950: '#0d1922',
};

/**
 * Escala oscura de Poseidon: el 0 es el texto y el 950 el fondo.
 * Muestreados de las pantallas Table, Chat y Dashboard.
 */
const poseidonSurfaceDark = {
  0: '#ffffff',
  50: '#e7eef8',
  100: '#d5deee',
  200: '#b7c3d6',
  300: '#9aa6ba',
  400: '#8b95a8',
  500: '#6d7b92',
  600: '#3d4d66',
  700: '#253044',
  800: '#192438',
  900: '#141f33',
  950: '#000c24',
};

export const MayorapPreset = definePreset(Aura, {
  semantic: {
    primary: palette('{blue}'),
    colorScheme: {
      light: {
        surface: poseidonSurface,
      },
      dark: {
        surface: poseidonSurfaceDark,
        content: {
          borderColor: '#4d5565',
        },
        formField: {
          borderColor: '#666d7b',
          hoverBorderColor: '#7b8393',
        },
      },
    },
  },
});
